var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('a-card',{attrs:{"title":"持仓文件下单"}},[_c('a-upload',{attrs:{"name":"orders","accept":".json","showUploadList":false,"beforeUpload":_vm.beforeUpload,"directory":true,"multiple":false}},[_c('a-button',{attrs:{"type":"primary"}},[_c('a-icon',{attrs:{"type":"upload"}}),_c('span',[_vm._v("打开配置文件夹")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }